import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import PipelineGeneral from './pipeline_general_view';
// import PipelineParser from './pipeline_parser_view';
import PipelineClassifier from './pipeline_classifier_list';
import { Tooltip, Divider, Tabs } from 'antd';
import PipelineNormalizer from './pipeline_normalizer';
import { overrideHeaderBack } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';

const pipeline_menu_item = ({ pipeline_id, pipeline_data, onPipelineChange,datatype_id }) => [
    {
        title: "General",
        key: "1",
        content: <PipelineGeneral
            pipeline_id={pipeline_id}
            datatype_id={datatype_id}
            pipeline_data={pipeline_data}
            onPipelineChange={onPipelineChange} />
    }, 
    // {
    //     title: "Sources",
    //     key: "2",
    //     content: <PipelineSources
    //         pipeline_id={pipeline_id}
    //         datatype_id={datatype_id}
    //         pipeline_data={pipeline_data}
    //         onPipelineChange={onPipelineChange} />
    // },
    //  {
    //     title: "Parser",
    //     key: "3",
    //     content: <PipelineParser
    //         pipeline_id={pipeline_id}
    //         datatype_id={datatype_id}
    //         pipeline_data={pipeline_data}
    //         onPipelineChange={onPipelineChange}
    //         />
    // }, 
    {
        title: "Normalizer",
        key: "4",
        content: <PipelineNormalizer
            pipeline_id={pipeline_id}
            datatype_id={datatype_id}
            pipeline_data={pipeline_data}
            onPipelineChange={onPipelineChange}
            />
    },  {
        title: "Classifiers",
        key: "5",
        content: <PipelineClassifier
            pipeline_id={pipeline_id}
            datatype_id={datatype_id}
            pipeline_data={pipeline_data}
            // onPipelineChange={onPipelineChange} 
            />
    }
];
class DataPipelineDetail extends Component {
    constructor(props) {
        super(props);

        this.datatype_id = props.match.params.datatype_id;
        this.pipeline_id = props.match.params.pipeline_id;

        this.state = {
            pipeline_detail: {},
            active_menu_key: "1"
        };

        this.get_pipeline = RESTExecutor
            .detail()
            .config({
                label: 'pipeline_detail',
                params: {
                    datatype_id: this.datatype_id,
                    pipeline_id: this.pipeline_id
                }
            })
            .callbacks((success) => {
                this.setState({ pipeline_detail: success.result });
                try{
                    window.header_assigner.assignTitle(success.result.name);
            
                }catch(e){}

            })
            .connect(props.domains.datatype);
    };

    onPipelineDataChange = () => {
        this
            .get_pipeline
            .execute();
    }
    render() {
        let get_pipeline_resp = this
            .get_pipeline
            .response();
        const { pipeline_detail, active_menu_key } = this.state;
        return (
            <ErrorWrapper
                error={get_pipeline_resp}
                onReload={() => {
                    this
                        .get_pipeline
                        .config({
                            params: {
                                datatype_id: this.datatype_id,
                                pipeline_id: this.pipeline_id
                            }
                        })
                        .execute();
                }}>
                <BasicHeader 
                title="Pipeline Detail"
                subtitle={pipeline_detail.name}

                />
                <div
                    className='default-card'
                    style={{
                        padding: 8
                    }}>
                    {/* <CustomHeader
                        title={pipeline_detail.name}
                    /> */}
                    {/* <Divider /> */}
                    <Tabs tabPosition='top'
                        onChange={(key) => {
                            // console.log("key is", key);
                            this.setState({
                                active_menu_key: key
                            })
                        }}
                        activeKey={active_menu_key}
                    >
                        {
                            pipeline_menu_item({
                                pipeline_data: pipeline_detail,
                                pipeline_id: pipeline_detail.id,
                                onPipelineChange: this.onPipelineDataChange,
                                datatype_id:this.datatype_id
                            }).map((item) => {
                                return <Tabs.TabPane key={item.key} tab={item.title}>
                                    <div style={{
                                        minHeight: 500
                                    }}>
                                        {active_menu_key === item.key ? item.content : null}
                                    </div>
                                </Tabs.TabPane>
                            })
                        }

                    </Tabs>
                </div>
            </ErrorWrapper>
        );
    }

    componentDidMount() {
        this
            .get_pipeline
            .execute();
            overrideHeaderBack(`back`)

    }
    componentWillUnmount(){
        overrideHeaderBack(null)
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.match.params.datatype_id !== prevProps.match.params.datatype_id || this.props.match.params.pipeline_id !== prevProps.match.params.pipeline_id) {
            this.datatype_id = this.props.match.params.datatype_id;
            this.pipeline_id = this.props.match.params.pipeline_id;
            this.setState({active_menu_key: "1"})
            // overrideHeaderBack(`/settings/datatype/${this.props.match.params.datatype_id}/pipelines`)
            this
                .get_pipeline
                .config({
                    params: {
                        datatype_id: this.datatype_id,
                        pipeline_id: this.pipeline_id
                    }
                })
                .execute();
            // this.get_source.forId(this.source_id).execute() fetch the new product based
            // and set it to the state of the component
        };
    }

}

export default withDomains(DataPipelineDetail, "datatype");
